module.exports = __webpack_public_path__ + "img/drac-as-a-bat.4de42eef.jpg";